import { Route, Routes } from "react-router-dom";

import styles from "../../styles/base/Portal.module.scss";

import Portal from "./Portal";
import { MSProvider } from "src/components/files/onedrive/context/MSContext";


export default function PortalRoutes(){
    return (
        <div className={styles.portal}>
            <MSProvider>
                <Routes>
                    <Route path="/*" element={<Portal />}/>
                </Routes>
            </MSProvider>
        </div>
    )
}
